import customAxios from './axios';
import CONFIG from '../../config';



export const getByBiometricBooking = async (id) => {
    try {
        const res = await customAxios.get(
            CONFIG.apiURL + `/BiometricAppointment/GetByBiometricBooking?id=${id}`
        );
        return res.data;
    } catch (err) {
        console.error("API error:", err?.response || err);
        throw err;
    }
};

export const biometricCheckout = async (bookingDetails) => {
    try {
        const res = await customAxios.post(
            CONFIG.apiURL + `/BiometricAppointment/Checkout`,
            bookingDetails
        );
        return res.data;
    } catch (err) {
        console.error("API error:", err?.response || err);
        throw err;
    }
}

export const biometricScheduleCreate = async (data) => {
    try {
        const res = await customAxios.post(
            CONFIG.apiURL + `/BiometricAppointment/CreateSchedule`,
            data
        );
        return res.data;
    } catch (err) {
        console.error("API error:", err?.response || err);
        throw err;
    }
}

